import { InjectionToken } from '@angular/core';

export const FORM_ERROR_TRANSLATIONS = new InjectionToken<string>('FORM_ERROR_TRANSLATIONS');
export type FormErrorTranslations = Record<string, ((...args: any) => string) | string>;
